import { render } from "./IshchiOquvRejalar.vue?vue&type=template&id=e02737c4&scoped=true"
import script from "./IshchiOquvRejalar.vue?vue&type=script&lang=js"
export * from "./IshchiOquvRejalar.vue?vue&type=script&lang=js"

import "./IshchiOquvRejalar.vue?vue&type=style&index=0&id=e02737c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e02737c4"]])

export default __exports__